export const DEFAULT_Z_INDEX = 1000;
export const PLACEMENT = {
  TOP: 'top',
  LEFT: 'left',
  BOTTOM: 'bottom',
  RIGHT: 'right',
} as const;

export interface MotionDrawerProps
  extends Pick<React.HTMLAttributes<HTMLDivElement>, 'children' | 'className'> {
  visible?: boolean;
  zIndex?: number;
  onClose?: (e: any) => void;
  parentNavEl?: HTMLElement;
  placement?: typeof PLACEMENT[keyof typeof PLACEMENT];
  transparent?: boolean;
}
